var x = function(y) {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = function(x) { return function() { return x; }; }
var __WEBPACK_NAMESPACE_OBJECT__ = x({ ["serializeError"]: function() { return __WEBPACK_EXTERNAL_MODULE_serialize_error_5f2df3e5__.serializeError; } });